export enum PortfolioFlagsEnum {
	EQUAL_WEIGHTS,
	VALUE,
	NO_VALUE,
	NO_WEIGTHS,
	NO_HOLDINGS,
	LINKED_MODEL,
	LIST_OF_HOLDINGS
}
